// Types
import { Settings } from "types/carousel";

// Utils
import { getFonts, getFontsQueryParam } from "./utils/get-fonts";

const FontsLinks = ({ settings }: {
  settings: Settings;
}) => {
  const { titleFontFamily, titleFontWeight, textFontFamily, textFontWeight } = getFonts(settings.fonts);
  const titleFontQueryParam = getFontsQueryParam(titleFontFamily, titleFontWeight);
  const textFontQueryParam = getFontsQueryParam(textFontFamily, textFontWeight);
  return (
    <>
      <link href={`https://fonts.googleapis.com/css2?${titleFontQueryParam}&display=swap"`} rel="stylesheet" />
      <link href={`https://fonts.googleapis.com/css2?${textFontQueryParam}&display=swap"`} rel="stylesheet" />
    </>
  )
}

export default FontsLinks;